import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { entitiesReducers as authSessionReducers } from "../../../modules/auth-session";
import { entitiesReducers as tokensReducers } from "../../../modules/tokens";
import sessionState from "./sessionState";
import flowType from "./flowType";

const chooseState = (state, initialState) => state === undefined ? initialState : state;

export default function createEntitiesReducer(initialState) {
  const {
    user,
    tokens,
    tokensPersistence
  } = _objectSpread(_objectSpread({}, authSessionReducers), tokensReducers);

  return function entitiesReducer(state = {}, action) {
    return {
      user: user(chooseState(state.user, initialState.user), action),
      tokens: tokens(chooseState(state.tokens, initialState.tokens), action),
      tokensPersistence: tokensPersistence(chooseState(state.tokensPersistence, initialState.tokensPersistence), action),
      sessionState: sessionState(chooseState(state.sessionState, initialState.sessionState), action),
      flowType: flowType(chooseState(state.flowType, initialState.flowType), action)
    };
  };
}